import { useParams, Navigate, Link } from "react-router-dom"

/** Redirect /blog/:id to /article/:id for backward compatibility. */
export default function BlogDetail() {
  const { id } = useParams()
  if (!id) {
    return (
      <div className="min-h-[40vh] flex flex-col items-center justify-center gap-4 px-4">
        <p className="text-muted-foreground text-center">Article non trouvé.</p>
        <Link
          to="/actualites"
          className="px-5 py-2.5 bg-primary text-primary-foreground rounded-lg text-sm font-semibold hover:bg-primary/90 transition-colors"
        >
          Voir les actualités
        </Link>
      </div>
    )
  }
  return <Navigate to={`/article/${id}`} replace />
}
